import { topicsData, cardsData, updatesData } from '@/mocks/51cgHomeData';

export function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">大家都在讨论的51cg吃瓜热点</p>

        <div className="flex flex-wrap gap-2.5 justify-center">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-accent-100/80 border-accent-200 text-accent-700 hover:bg-accent-200/80'
                  : 'bg-background-100 border-background-200/70 text-foreground-600 hover:border-background-300 hover:bg-background-200/60'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-[10px] md:text-xs opacity-60">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          深度扒料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">51cg深度吃瓜文章精选</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="flex flex-col rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer group h-full"
            >
              <div className="relative w-full aspect-[16/9] bg-background-200 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-accent-100/30 to-secondary-100/30 flex items-center justify-center">
                  <span className="text-4xl opacity-30">
                    <i className="ri-article-line"></i>
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {card.excerpt}
                </p>
                <span className="text-xs text-foreground-400">{card.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2 text-center">
          最新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">51cg吃瓜实时动态追踪</p>

        <div className="space-y-2">
          {updatesData.map((update) => (
            <div
              key={update.id}
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-2 h-2 rounded-full ${
                update.type === 'hot' ? 'bg-accent-500' : 'bg-primary-500'
              }`}></span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 group-hover:text-accent-600 transition-colors line-clamp-1">
                {update.title}
              </span>
              <span className="flex-shrink-0 text-xs text-foreground-400 whitespace-nowrap">
                {update.time}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}